import axios from "axios";
import { setAlert } from "./alert";
import {
  GET_FRIENDS,
  GET_USER_FRIENDS,
  SEND_USER_REQUEST,
  SEND_BUSINESS_CASUAL_REQUEST,
  FOLLOW_USER,
  SEND_MENTOR_CASUAL_REQUEST,
  SEND_MENTOR_FOLLOW_REQUEST,
  SEND_EMPLOYER_CASUAL_REQUEST,
  SEND_EMPLOYER_FOLLOW_REQUEST,
  REMOVE_APPROVAL_REQUEST,
  FRIEND_ERROR,
  REMOVE_FRIEND,
  ADD_FRIEND,
  CLEAR_FRIENDS,
} from "./types";

// Get friends/users by profile channelid
export const getUsers = (channelid) => async (dispatch) => {
  dispatch({ type: CLEAR_FRIENDS });
  try {
    const res = await axios.post(`/api/friend/${channelid}`);

    dispatch({
      type: GET_FRIENDS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get friends/users by user channelid
export const getLoggedInUsers = () => async (dispatch) => {
  dispatch({ type: CLEAR_FRIENDS });
  try {
    const res = await axios.post(`/api/friend/userfriends`);

    dispatch({
      type: GET_USER_FRIENDS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Send Pending Friend Request
export const sendUserRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/friend", formData, config);

    dispatch({
      type: SEND_USER_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("Request Sent"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add following friend as a Friend
export const addFollowingFriend = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/friends", formData, config);

    dispatch({
      type: SEND_USER_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("Request Sent"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Follow a user
export const followUser = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/follow", formData, config);

    dispatch({
      type: FOLLOW_USER,
      payload: res.data,
    });

    dispatch(setAlert("Following"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Accept Friend Request
export const acceptFriendRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/accept", formData, config);

    dispatch({
      type: ADD_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("Request Accepted"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Accept Friend Request
export const declineFriendRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/decline", formData, config);

    dispatch({
      type: REMOVE_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("Request Accepted"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Cancel Friend Request
export const cancelFriendRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/cancel", formData, config);

    dispatch({
      type: REMOVE_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("Request Accepted"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Accept Approval Request
export const acceptApprovalRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/approve", formData, config);

    dispatch({
      type: ADD_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("Request Accepted"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Cancel/ Remove Friend
export const unfollowUser = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/unfollow", formData, config);

    dispatch({
      type: REMOVE_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("User Removed"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

//Remove Friend
export const removeCasualFriend = (formData, channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      `/api/friend/user/removefriend/${channelid}`,
      formData,
      config
    );

    dispatch({
      type: REMOVE_FRIEND,
      payload: res.data,
    });

    dispatch(setAlert("User Removed"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove approved Mentor
export const removeApprovalRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "/api/friend/user/removeapprovalrequest",
      formData,
      config
    );

    dispatch({
      type: REMOVE_APPROVAL_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("User Removed"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Cancel approved Mentor request
export const cancelApprovalRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "/api/friend/user/cancelapprovalrequest",
      formData,
      config
    );

    dispatch({
      type: REMOVE_APPROVAL_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("User Removed"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Decline approved Mentor request
export const declineApprovalRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(
      "/api/friend/user/declineapprovalrequest",
      formData,
      config
    );

    dispatch({
      type: REMOVE_APPROVAL_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("User Removed"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Send Approval Request to Mentor
export const sendApprovalRequest = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post("/api/friend/user/approval", formData, config);

    dispatch({
      type: SEND_USER_REQUEST,
      payload: res.data,
    });

    dispatch(setAlert("Request Sent"));
  } catch (err) {
    dispatch({
      type: FRIEND_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
